//main application
import React, { useEffect, useState, useContext } from 'react';
import './styles/app.scss';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { LicenseInfo } from '@mui/x-license';

import { getAppMaintenance } from './api/maintenance';
import { SecurityProvider, PrivateRoute, useSecurity } from './components/Security/security';
import { StoreContext } from './components/Store';
import { SSOProvider } from './components/SSO/SSO';

import Layout from './layout/Layout';
import LandingPage from './pages/LandingPage';
import LandingPage360 from './pages/LandingPage360';
import Login from './pages/Authentication/Login';

import MaintenancePage from './pages/MaintenancePage';
import ErrorSnackbar from './components/Errors/ErrorSnackbar';

import RegistrationContainer from './pages/Registration/RegistrationContainer';

import PasswordResetByUser from './pages/Authentication/PasswordResetByUser';
import ConfirmResetFromEmail from './pages/Authentication/ConfirmResetFromEmail';

import SelectCompanyForENS from './pages/Decs/Screens/0. Select Company';
import GBENSContainer from './pages/Decs/GBENSContainer';

import Dashboard from './pages/Dashboard/Dashboard';
import ShipmentView from './pages/Dashboard/ShipmentView';
import PrintablePage from './pages/Dashboard/PrintablePage';

import CustomerSettings from './pages/Settings/CustomerSettings';
import SelectCustomer from './pages/Settings/SelectCustomer';
import ReportingContainer from './pages/Reporting/ReportingContainer';

function App() {
  const store = useContext(StoreContext);
  const siteConfig = store.wlpConfig[0];

  const [maintenanceFlag, setMaintenanceFlag] = useState();
  const [maintenanceMessage, setMaintenanceMessage] = useState();

  useEffect(() => {
    const fetch = async () => {
      const data = await getAppMaintenance();
      setMaintenanceFlag(parseInt(data.flag));
      setMaintenanceMessage(data.message);
    };
    fetch();

    const env = process.env.REACT_APP_ENV || 'prod';
    const robotsMeta = document.getElementById('robotsMeta');
    if (['dev', 'test'].includes(env)) {
      if (robotsMeta) {
        robotsMeta.setAttribute('content', 'noindex');
      } else {
        const noIndex = document.createElement('meta');
        noIndex.setAttribute('id', 'robotsMeta');
        noIndex.setAttribute('name', 'robots');
        noIndex.setAttribute('content', 'noindex');
        document.head.appendChild(noIndex);
      }
    } else if (robotsMeta) {
      robotsMeta.remove();
    }
  }, []);

  useEffect(() => {
    if (siteConfig?.wlpName) {
      document.body.setAttribute('data-wlp-name', siteConfig.wlpName);
    }
  }, [siteConfig]);

  useEffect(() => {
    LicenseInfo.setLicenseKey(
      '14364f1922c59a71b819de9105bfb4dfTz0xMjQ0NDgsRT0xODAwMjMwMzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='
    );
  });

  return (
    <div className="App">
      <ErrorSnackbar
        message={store.errorSnackbarMessage[0]}
        isOpen={store.showErrorSnackbar[0]}
        onClose={() => store.hideError()}
      />
      <Router>
        <SecurityProvider>
          <SSOProvider isDisabled={siteConfig.wlpName !== '360PAY'}>
            <Routes>
              {maintenanceFlag ? (
                <Route
                  exact
                  path="*"
                  element={<MaintenancePage maintenanceMessage={maintenanceMessage} auth={false} />}
                  auth={false}
                />
              ) : (
                <Route element={<Layout />}>
                  <Route
                    exact
                    path="/"
                    element={
                      siteConfig.wlpName === '360PAY' ? <LandingPage360 auth={false} /> : <LandingPage auth={false} />
                    }
                  />
                  <Route exact path="/login" element={<Login />} auth={false} />
                  <Route exact path="/confirmreset/:token" element={<ConfirmResetFromEmail />} auth={false} />
                  <Route exact path="/PasswordReset" element={<PasswordResetByUser />} auth={false} />
                  <Route exact path="/register" element={<RegistrationContainer />} auth={false} />
                  <Route exact path="/" element={<PrivateRoute />}>
                    <Route
                      exact
                      path="/EnsDeclarationSelectCompany"
                      element={
                        <div className="full-page-wrapper">
                          <SelectCompanyForENS />
                        </div>
                      }
                      auth={false}
                    />
                    <Route
                      exact
                      path="/EnsDeclaration"
                      element={
                        <div className="full-page-wrapper">
                          <GBENSContainer />
                        </div>
                      }
                      auth={false}
                    />

                    <Route
                      exact
                      path="/Dashboard"
                      element={
                        <div className="full-page-wrapper">
                          <Dashboard />
                        </div>
                      }
                      auth={false}
                    />
                    <Route
                      exact
                      path="/ShipmentView"
                      element={
                        <div className="full-page-wrapper">
                          <ShipmentView />
                        </div>
                      }
                      auth={false}
                    />
                    <Route exact path="/printShipment" element={<PrintablePage />} auth={false} />

                    <Route
                      exact
                      path="/SelectCustomer"
                      element={
                        <div className="full-page-wrapper">
                          <SelectCustomer />
                        </div>
                      }
                      auth={false}
                    />
                    <Route
                      exact
                      path="/CustomerSettings"
                      element={
                        <div className="full-page-wrapper">
                          <CustomerSettings />
                        </div>
                      }
                      auth={false}
                    />
                    <Route
                      exact
                      path="/Reporting"
                      element={
                        <div className="full-page-wrapper">
                          <ReportingContainer />
                        </div>
                      }
                      auth={false}
                    />
                  </Route>
                  Dashboard
                </Route>
              )}
            </Routes>
          </SSOProvider>
        </SecurityProvider>
      </Router>
    </div>
  );
}

export default App;
